import React, { useEffect, useState } from "react";
import { WifiOff, X } from "lucide-react";

export default function OfflineAlert() {
  const [isOffline, setIsOffline] = useState(
    typeof navigator !== "undefined" ? !navigator.onLine : false
  );
  const [dismissed, setDismissed] = useState(false);

  useEffect(() => {
    let cancelled = false;

    const checkConnection = async () => {
      try {
        await fetch("https://www.google.com/generate_204", {
          method: "HEAD",
          mode: "no-cors",
          cache: "no-store",
        });
        if (!cancelled) setIsOffline(false);
      } catch {
        if (!cancelled) setIsOffline(true);
      }
    };

    const handleOnline = () => {
      setIsOffline(false);
      setDismissed(false);
    };
    const handleOffline = () => {
      setIsOffline(true);
      setDismissed(false);
    };

    window.addEventListener("online", handleOnline);
    window.addEventListener("offline", handleOffline);

    // Run one probe on mount to establish ground truth
    checkConnection();

    // Re-probe every 30 seconds while offline — auto-recovers the banner
    const intervalId = setInterval(() => {
      if (isOffline) checkConnection();
    }, 30000);

    return () => {
      cancelled = true;
      window.removeEventListener("online", handleOnline);
      window.removeEventListener("offline", handleOffline);
      clearInterval(intervalId);
    };
  }, [isOffline]);

  if (!isOffline || dismissed) return null;

  return (
    <div className="fixed left-0 right-0 top-0 z-50 animate-slide-down bg-red-500 text-white shadow-lg">
      <div className="mx-auto flex max-w-7xl items-center justify-between gap-3 px-4 py-3 sm:px-6">
        <div className="flex items-center gap-3">
          <WifiOff className="h-5 w-5 flex-none" />
          <div className="min-w-0">
            <div className="text-sm font-semibold">No Internet Connection</div>
            <div className="text-xs text-red-50">
              Please check your connection. Some features may not work properly.
            </div>
          </div>
        </div>
        <button
          type="button"
          onClick={() => setDismissed(true)}
          aria-label="Dismiss"
          className="flex-none rounded-md p-1 text-white/80 transition-colors hover:bg-red-600 hover:text-white"
        >
          <X className="h-4 w-4" />
        </button>
      </div>
    </div>
  );
}
